import { defineComponent as _defineComponent } from 'vue'
import { toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/Grey/Back.svg'


const _withScopeId = n => (_pushScopeId("data-v-313dddf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "ask-arrow-seperator"
}, null, -1))
const _hoisted_3 = ["value"]

import { computed, onMounted, ref } from 'vue'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import store from '@/store'

const dateFormat = 'DD-MMM-YYYY'

interface Props {
    from: Date
    to: Date
    onChange: ({ from, to }: { from: Date; to: Date }) => void
    startOpen?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangeInput',
  props: {
    from: { default: new Date() },
    to: { default: new Date() },
    onChange: {},
    startOpen: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const isMobile = computed(() => store.getters.isMobile)

const startDatePickerOpen = ref(false)

const range = ref({
    start: props.from,
    end: props.to,
})

const masks = {
    input: dateFormat,
}

onMounted(() => {
    startDatePickerOpen.value = props.startOpen || false
})

const getColumns = () => {
    return !isMobile.value ? 2 : 1
}

const applyChange = () => {
    if (
        !range.value ||
        (range.value?.start === props.from && range.value?.end === props.to)
    ) {
        return
    }

    props.onChange({
        from: range.value.start,
        to: range.value.end,
    })
}

const showDatePickerOnOpen = (showPopover: Function) => {
    if (startDatePickerOpen.value) {
        showPopover()
        startDatePickerOpen.value = false
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), {
    modelValue: range.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
      applyChange
    ],
    mode: "date",
    color: "blue",
    masks: masks,
    "first-day-of-week": 2,
    columns: getColumns(),
    "is-range": ""
  }, {
    default: _withCtx(({ inputValue, inputEvents, showPopover }) => [
      _createElementVNode("input", _mergeProps({
        value: inputValue.start,
        class: "ask-date-range-input"
      }, _toHandlers(inputEvents.start, true)), null, 16, _hoisted_1),
      _hoisted_2,
      _createElementVNode("input", _mergeProps({
        value: inputValue.end,
        class: "ask-date-range-input"
      }, _toHandlers(inputEvents.end, true)), null, 16, _hoisted_3),
      _createTextVNode(" " + _toDisplayString(showDatePickerOnOpen(showPopover)), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "columns"]))
}
}

})